const themes = [
  {
    "color": "red",
    "class": "text--disabled",
    "primary": "#F44336",
    "secondary": "#D32F2F",
    "accent": "#FF5252",
    "info": "#E57373",
    "error": "#9E9E9E"
  },
  {
    "color": "pink",
    "class": "text--disabled",
    "primary": "#E91E63",
    "secondary": "#C2185B",
    "accent": "#FF4081",
    "info": "#F06292",
    "error": "#9E9E9E"
  },
  {
    "color": "purple",
    "class": "text--disabled",
    "primary": "#9C27B0",
    "secondary": "#7B1FA2",
    "accent": "#E040FB",
    "info": "#BA68C8",
    "error": "#9E9E9E"
  },
  {
    "color": "deep-purple",
    "class": "text--disabled",
    "primary": "#673AB7",
    "secondary": "#512DA8",
    "accent": "#7C4DFF",
    "info": "#9575CD",
    "error": "#9E9E9E"
  },
  {
    "color": "indigo",
    "class": "text--disabled",
    "primary": "#3F51B5",
    "secondary": "#303F9F",
    "accent": "#536DFE",
    "info": "#7986CB",
    "error": "#9E9E9E"
  },
  {
    "color": "blue",
    "class": "text--disabled",
    "primary": "#2196F3",
    "secondary": "#1976D2",
    "accent": "#448AFF",
    "info": "#64B5F6",
    "error": "#9E9E9E"
  },
  {
    "color": "light-blue",
    "class": "text--disabled",
    "primary": "#03A9F4",
    "secondary": "#0288D1",
    "accent": "#40C4FF",
    "info": "#4FC3F7",
    "error": "#9E9E9E"
  },
  {
    "color": "cyan",
    "class": "text--disabled",
    "primary": "#00BCD4",
    "secondary": "#0097A7",
    "accent": "#18FFFF",
    "info": "#4DD0E1",
    "error": "#9E9E9E"
  },
  {
    "color": "teal",
    "class": "text--disabled",
    "primary": "#009688",
    "secondary": "#00796B",
    "accent": "#64FFDA",
    "info": "#4DB6AC",
    "error": "#9E9E9E"
  },
  {
    "color": "green",
    "class": "text--disabled",
    "primary": "#4CAF50",
    "secondary": "#388E3C",
    "accent": "#69F0AE",
    "info": "#81C784",
    "error": "#9E9E9E"
  },
  {
    "color": "light-green",
    "class": "text--disabled",
    "primary": "#8BC34A",
    "secondary": "#1B5E20",
    "accent": "#64DD17",
    "info": "#AED581",
    "error": "#9E9E9E"
  },
  {
    "color": "lime",
    "class": "text--disabled",
    "primary": "#CDDC39",
    "secondary": "#AFB42B",
    "accent": "#827717",
    "info": "#DCE775",
    "error": "#9E9E9E"
  },
  {
    "color": "amber",
    "class": "text--disabled",
    "primary": "#FFC107",
    "secondary": "#FFA000",
    "accent": "#FFD740",
    "info": "#FFD54F",
    "error": "#9E9E9E"
  },
  {
    "color": "orange",
    "class": "text--disabled",
    "primary": "#FF9800",
    "secondary": "#F57C00",
    "accent": "#FFAB40",
    "info": "#FFB74D",
    "error": "#9E9E9E"
  },
  {
    "color": "deep-orange",
    "class": "text--disabled",
    "primary": "#FF5722",
    "secondary": "#E64A19",
    "accent": "#FF6E40",
    "info": "#FF8A65",
    "error": "#9E9E9E"
  },
  {
    "color": "brown",
    "class": "text--disabled",
    "primary": "#795548",
    "secondary": "#5D4037",
    "accent": "#D7CCC8",
    "info": "#A1887F",
    "error": "#9E9E9E"
  },
  {
    "color": "blue-grey",
    "class": "text--disabled",
    "primary": "#607D8B",
    "secondary": "#455A64",
    "accent": "#CFD8DC",
    "info": "#90A4AE",
    "error": "#9E9E9E"
  }
];

export default themes;
